import React from 'react'
import classnames from 'classnames'
import PrimaryButton from 'components/PrimaryButton'

const DarkPrimaryButton = ({ className, ...rest }) => (
  <PrimaryButton className={classnames('text-sm px-6 bg-woodsmokeBlack', className)} {...rest} />
)

export default DarkPrimaryButton
